"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _WeekDays = _interopRequireDefault(require("./WeekDays.style"));

var _Label = _interopRequireDefault(require("../../Label"));

var _dec, _class;

let WeekDays = (_dec = (0, _reactJss.default)(_WeekDays.default), _dec(_class = class WeekDays extends _react.PureComponent {
  render() {
    const {
      isoDays,
      classes,
      size,
      className
    } = this.props;
    const weekDayList = isoDays ? ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'] : ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(className, classes[size], classes.weekDayList)
    }, weekDayList.map((weekDay, index) => /*#__PURE__*/_react.default.createElement(_Label.default, {
      key: index,
      fontSize: size,
      className: (0, _clsx.default)(classes.weekDay),
      value: weekDay
    })));
  }

}) || _class);
var _default = WeekDays;
exports.default = _default;